import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export class FormUtil {
    public static clone<T extends AbstractControl>(oldControl: T): T {
        if (oldControl instanceof UntypedFormGroup) {
            const formGroup = new UntypedFormGroup({}, oldControl.validator, oldControl.asyncValidator);
            Object.keys(oldControl.controls).forEach((controlName: string) =>
                formGroup.addControl(controlName, this.clone(oldControl.controls[controlName])));
            return formGroup as any;
        } else if (oldControl instanceof UntypedFormArray) {
            const formArray = new UntypedFormArray([], oldControl.validator, oldControl.asyncValidator);
            oldControl.controls.forEach((control: AbstractControl) => formArray.push(this.clone(control)));
            return formArray as any;
        } else if (oldControl instanceof UntypedFormControl) {
            return new UntypedFormControl(oldControl.value, oldControl.validator, oldControl.asyncValidator) as any;
        } else {
            throw new Error('Unexpected abstract control');
        }
    }

    public static hasValidator(control: UntypedFormControl): boolean {
        return control && control.validator && control.validator({} as AbstractControl) ? true : false;
    }
}
